(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
